export const rankInitialState = [{
    id: "1",
    academicRank: "Msc",
    payment_rate: "200"
},
{
    id: "2",
    academicRank: "Phd",
    payment_rate: "250"
}
]